/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { GiveawayItem } from './GiveawayItem';
export type GiveawayRoundResponse = {
    /**
     * Giveaway round ID
     */
    id: string;
    /**
     * 0=WAITING, 10=ACTIVE, 20=PICKING, 30=DONE, 40=ERROR
     */
    status: GiveawayRoundResponse.status;
    /**
     * Item to be given away
     */
    item: GiveawayItem;
    /**
     * Current number of participants
     */
    participantCount: number;
    /**
     * Minimum participants required
     */
    minimumParticipants: number;
    /**
     * When the round ends (null if WAITING)
     */
    endsAt?: string | null;
    /**
     * Whether the current user has joined
     */
    userJoined: boolean;
    /**
     * Whether the current user can join (validates all requirements)
     */
    canJoin: boolean;
    giveawayType: {
        /**
         * Giveaway name
         */
        name: string;
        /**
         * Required Steam level
         */
        requiredSteamLevel: number;
        /**
         * Required user level
         */
        requiredLevel: number;
        /**
         * Required deposit amount in cents
         */
        requiredDepositAmount: number;
        /**
         * Required deposit within X days
         */
        requiredDepositSinceDays: number;
        /**
         * Whether email verification is required to join
         */
        emailVerifiedRequired: boolean;
        /**
         * Maximum tickets allowed per user
         */
        maxTickets?: number;
    };
};
export namespace GiveawayRoundResponse {
    /**
     * 0=WAITING, 10=ACTIVE, 20=PICKING, 30=DONE, 40=ERROR
     */
    export enum status {
        '_0' = 0,
        '_10' = 10,
        '_20' = 20,
        '_30' = 30,
        '_40' = 40,
    }
}

